import type { LucideIcon } from 'lucide-react';

export interface SummaryCardItem {
	icon: LucideIcon;
	label: string;
	value: string;
	color?: string;
}

interface SummaryCardsProps {
	cards: SummaryCardItem[];
	className?: string;
}

export default function SummaryCards({ cards, className }: SummaryCardsProps) {
	return (
		<div className={`grid grid-cols-2 gap-2 ${className ?? ''}`}>
			{cards.map(({ icon: Icon, label, value, color = 'text-foreground' }) => (
				<div key={label} className='rounded-md border border-border bg-card p-3.5 flex flex-col gap-1.5'>
					<div className='flex items-center gap-1.5 text-xs text-muted-foreground'>
						<Icon size={14} className='opacity-50' />
						{label}
					</div>
					<span className={`text-sm font-semibold tabular-nums ${color}`}>{value}</span>
				</div>
			))}
		</div>
	);
}
